import getConfig from 'next/config';
import logger from '@utils/logger';
import {
  AlgoliaSearchClient,
  PrismicService,
  ProductService,
  UserService,
  WishlistService,
  ProductReviewsService,
  GrowthbookService,
  ShoppingCartService,
} from '@monofront/business/services';
import { CustomerCRUD } from './user/CustomerCRUD';
import { AuthCRUD } from './user/AuthCRUD';
import firebaseService from './firebase';
import { WishlistCRUD } from './wishlist';
import isProductionMode from '@utils/isProductionMode';
import { isInPrismicPreview } from '@utils/prismic';
import { trackGrowthbookExperimentViewed } from '@utils/tracking';
import initApollo from '@utils/apollo/initApollo';

const {
  publicRuntimeConfig: { algoliaConfig, prismicConfig, legoUrl },
  serverRuntimeConfig,
} = getConfig();

const customerCRUD = new CustomerCRUD();
const authCRUD = new AuthCRUD();
const algoliaSearchClient = new AlgoliaSearchClient(algoliaConfig);
// SSR reads Prismic through the in-cluster caching proxy (serverRuntimeConfig is empty in the browser,
// which keeps the public CloudFront URL).
const prismicService = new PrismicService(
  serverRuntimeConfig?.prismicInternalApiUrl
    ? { ...prismicConfig, apiUrl: serverRuntimeConfig.prismicInternalApiUrl }
    : prismicConfig,
  logger,
);
const growthBookService = new GrowthbookService(
  isProductionMode === false || isInPrismicPreview(),
  logger,
  trackGrowthbookExperimentViewed,
);
const productService = new ProductService(
  algoliaConfig,
  algoliaSearchClient,
  growthBookService,
  logger,
  initApollo,
);
const wishlistCRUD = new WishlistCRUD(productService);
const userService = new UserService(customerCRUD, authCRUD, legoUrl);
const wishlistService = new WishlistService(wishlistCRUD);
const productReviewsService = new ProductReviewsService(productService);

const shoppingCartService = new ShoppingCartService(
  firebaseService,
  productService,
);

const searchClient = algoliaSearchClient.searchClient;

export {
  prismicService,
  searchClient,
  productService,
  customerCRUD,
  authCRUD,
  userService,
  wishlistService,
  productReviewsService,
  shoppingCartService,
  growthBookService,
};
